



























































import { Auth } from "aws-amplify";
import { Component, Mixins } from "vue-property-decorator";

import HasAlerts from "@/mixins/HasAlerts.vue";
import AlertList from "@/components/AlertList.vue";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: { AlertList }
})
export default class ForgotPasswordSubmit extends Mixins(HasAlerts) {
  private email: string = "";

  private code: string = "";

  private password: string = "";

  private status: "Loading" | "Idle" = "Idle";

  async submit() {
    try {
      this.status = "Loading";

      await Auth.forgotPasswordSubmit(this.email, this.code, this.password);

      this.flash(
        {
          type: "success",
          message: `Your password has been reset. Please sign in.`
        },
        { global: true }
      );

      this.$router.push("/login");
    } catch (ex) {
      this.flash(
        {
          type: "danger",
          message: ex.message || ex
        },
        { global: false }
      );
    } finally {
      this.status = "Idle";
    }
  }

  async mounted() {
    this.email = this.$route.query.email as string;
  }

  async beforeRouteEnter(to: any, from: any, next: any) {
    next(typeof to.query.email === "string" ? undefined : "/login");
  }
}
